import React, { useState, useEffect } from 'react';

import { FirstDatabaseGAOnboarding } from '@confluence/databases-onboarding-ga/entry-points/FirstDatabaseGAOnboarding.ts';

import type { DatabaseOnboardingService } from './services/database-onboarding-service.ts';

export const DatabaseOnboarding = ({
	onboardingService,
}: {
	onboardingService: DatabaseOnboardingService;
}) => {
	const [onboardingStep, setOnboardingStep] = useState<string>();

	useEffect(() => {
		onboardingService.registerOnOnboardingChangeCallback((step) => {
			setOnboardingStep(step);
		});
	}, [onboardingService]);

	return <FirstDatabaseGAOnboarding currentStep={onboardingStep} setNextStep={setOnboardingStep} />;
};
